// extracted by mini-css-extract-plugin
export default {"main_cart":"CartCard_main_cart__Ozpgn","card_action":"CartCard_card_action__U0MQU","img_box":"CartCard_img_box__cL7ot","img":"CartCard_img__MYDo8"};